import { render, staticRenderFns } from "./NoSidebar.vue?vue&type=template&id=0e1d5066&scoped=true&"
import script from "./NoSidebar.vue?vue&type=script&lang=js&"
export * from "./NoSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e1d5066",
  null
  
)

export default component.exports